import {Component, Input} from '@angular/core';

const AVATAR_COLORS = [
    {background: '#dbeafe', foreground: '#1e40af'},
    {background: '#dcfce7', foreground: '#166534'},
    {background: '#fef3c7', foreground: '#92400e'},
    {background: '#fce7f3', foreground: '#9d174d'},
    {background: '#ede9fe', foreground: '#5b21b6'},
    {background: '#cffafe', foreground: '#155e75'},
    {background: '#ffedd5', foreground: '#9a3412'},
    {background: '#e2e8f0', foreground: '#334155'},
];

@Component({
    selector: 'app-identity-avatar',
    template: `
        <img *ngIf="imageUrl?.trim() && imageUrl !== failedImageUrl; else letter"
             [src]="imageUrl" alt="" (error)="failedImageUrl = imageUrl" />
        <ng-template #letter>{{ initials || '?' }}</ng-template>
    `,
    styles: [`
        :host {
            display: inline-flex;
            flex: 0 0 auto;
            align-items: center;
            justify-content: center;
            width: 2.5rem;
            height: 2.5rem;
            overflow: hidden;
            border-radius: 0.75rem;
            font-size: 0.875rem;
            font-weight: 700;
            line-height: 1;
        }

        img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    `],
    host: {
        'aria-hidden': 'true',
        '[style.backgroundColor]': 'colors.background',
        '[style.color]': 'colors.foreground',
    },
})
export class IdentityAvatarComponent {
    @Input() imageUrl?: string | null;
    @Input() initials = '?';
    @Input() colorKey = '';

    failedImageUrl?: string | null;

    get colors() {
        // The same identity always picks the same pair, even after reloading or sorting.
        let hash = 0;
        for (const character of this.colorKey.trim().toLowerCase()) {
            hash = (Math.imul(31, hash) + character.charCodeAt(0)) | 0;
        }
        return AVATAR_COLORS[(hash >>> 0) % AVATAR_COLORS.length];
    }
}
